import { render } from "./RegistrationYear.vue?vue&type=template&id=7b5df25a"
import script from "./RegistrationYear.vue?vue&type=script&lang=js"
export * from "./RegistrationYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__